export default __webpack_public_path__ + "static/media/mask-icon.91dcc3b0.svg";